<template>
  <div>
    <b-modal ref="deleteConfirmModal" hide-footer title="Project Deletion Confirmation" @hidden="hidden">
      <div class="d-block text-center">
        <h3>WARNING: This is a destructive operation that cannot be undone.</h3>
        <h5>This will delete all data associated with the project <strong>{{projectName}}</strong></h5>
      </div>
      <b-form-input @keydown.enter.native="enter_handler" v-model="projectConfirmName" placeholder="Type the name of the project to confirm DELETION:" class="mt-3"></b-form-input>
      <b-form-invalid-feedback :state="errorMessage === ''">
        {{errorMessage}}
      </b-form-invalid-feedback>
      <b-button class="mt-3" variant="outline-danger" block @click="deleteProjectClicked">DELETE</b-button>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { ProjectDeleteSession } from '#/services/workspace/project';

export default {
  data() {
    return {
      errorMessage: '',
      projectConfirmName: '',
      project: undefined,
    };
  },
  computed: {
    projectName() {
      if (this.project) {
        return this.project.name;
      }
      return '';
    },
    projects() {
      return this.$store.getters.projects;
    },
  },
  methods: {
    resetInfo() {
      this.errorMessage = '';
      this.projectConfirmName = '';
      this.project = undefined;
    },
    showDeleteConfirmation(project) {
      if (!project) {
        console.error('must specify project to delete');
        return;
      }
      if (this.project) {
        console.warn('cannot delete more than one project at a time. current delete', this.project, 'new delete', project);
        return;
      }
      console.info('confirming delete in modal for project', project);
      this.resetInfo();
      Vue.set(this, 'project', project);
      this.project = project;
      this.$refs.deleteConfirmModal.show();
    },
    hidden() {
      console.info('project delete modal HIDDEN');
      this.resetInfo();
    },
    deleteProjectClicked() {
      // TODO: confirmation modal
      console.info('deleting project', this.project.projectId, this.project.name);
      const session = new ProjectDeleteSession(this.project.projectId);
      return session.deleteProject(this.projectConfirmName).then(() => {
        console.info('deleted project', this.project);
        this.$store.commit('removeProject', this.project.projectId);
        this.$refs.deleteConfirmModal.hide();
        // TODO: remove from store
        //
      }).catch((error) => {
        console.warn('project deletion error', error);
        this.errorMessage = error.message;
      }); // TODO: force confirmation from modal of project.name
    },
    enter_handler(event) {
      if (event.which === 13) {
        // if 13 the key pressed was the enter key
        // TODO: should enter be allowed on something as fatal as project delete? we have had them type the name after all.
        this.deleteProjectClicked();
      }
    },
  },
};
</script>

<style scoped>

</style>
